import React from 'react';

const LoadingState = () => {
    return (
        <div className="loading-dashboard">
            <div className="spinner"></div>
            <p>Загрузка данных...</p>
        </div>
    );
};

export default LoadingState;